export const PERMISSIONS = {
  CREATE_CABINET: "create_cabinet",
  READ_CABINET: "read_cabinet",
  UPDATE_CABINET: "update_cabinet",
  DELETE_CABINET: "delete_cabinet",
  READ_ORDERS: "read_orders",
  REFUND_ORDERS: "refund_orders",
  CREATE_USERS: "create_users",
  READ_USERS: "read_users",
  UPDATE_USERS: "update_users",
  DELETE_USERS: "delete_users",
  GENERATE_REPORTS: "generate_reports",
  VIEW_REPORTS: "view_reports",
  READ_CUSTOMERS: "read_customers",
  LIST_KIOSKS: "list_kiosks",
  CREATE_ADVERTISEMENTS: "create_advertisements",
  UPDATE_ADVERTISEMENTS: "only_for_superadmin",
  READ_ADVERTISEMENTS: "read_advertisements",
  EJECT_BATTERY: "eject_battery",
  DELETE_ADVERTISEMENT: "only_for_superadmin",
  DELETE_ROLE: "only_for_superadmin",
  ONLY_FOR_SUPERADMIN: "only_for_superadmin",
  READ_PRICINGS: "only_for_superadmin",
  CREATE_PRICINGS: "only_for_superadmin",
  UPDATE_PRICINGS: "only_for_superadmin",
  DELETE_PRICINGS: "only_for_superadmin"
};
